import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import SharedForm from '../../../components/ui/Form';
import { formatAddress } from '../../../utils/utils';
import { ALIGN, POSITIONS, VALIDATIONS } from '../../../constants';

const ViewOutreachDetailsModal = ({ show, onCancel, data }) => {
    const [outreachDetails, setOutreachDetails] = useState(null);

    useEffect(() => {
        if (data !== null) {
            const formattedAddress = formatAddress(data.addressLine1, data.addressLine2, data.city, data.state, data.postalCode);
            setOutreachDetails({ ...data, formattedAddress });
        }
    }, [data, show]);

    const arr = [
        {
            key: 'firstName',
            labelName: 'First Name',
            type: 'text',
            required: false,
        },
        {
            key: 'lastName',
            labelName: 'Last Name',
            type: 'text',
            required: false,
        },
        {
            key: 'empaneledDate',
            labelName: 'Empaneled Date',
            type: 'date',
            required: false,
        },
        {
            key: 'dateOfBirth',
            labelName: 'Birthdate',
            type: 'date',
            required: false,
        },
        {
            key: 'healthPlanMemberId',
            labelName: 'Health Plan ID',
            type: 'text',
            required: false,
        },
        {
            key: 'memberCommunicationLastDate',
            labelName: 'Last Outreach Date',
            type: 'date',
            required: false,
        },
        {
            key: 'formattedAddress',
            labelName: 'Address',
            placeholderName: 'Address',
            type: 'textarea',
            required: false,
            copy: true,
        },
        {
            key: 'phone',
            labelName: 'Phone',
            placeholderName: 'Phone',
            type: 'tel',
            maxLength: 12,
            required: false,
            valid: VALIDATIONS.Number.isPhone,
        },
        {
            key: 'email',
            labelName: 'Email',
            placeholderName: 'Email',
            type: 'email',
            required: false,
        },
    ];

    const handleCancel = () => {
        onCancel();
        setOutreachDetails(null);
    };

    return (
        <Modal
            show={show}
            fullscreen={false}
            backdrop="static"
            onHide={handleCancel}
            size="md">
            <Modal.Header closeButton>
                <Modal.Title>Member Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="px-xl-3 py-xl-2">
                    <SharedForm
                        cols={12}
                        array={arr}
                        modelObj={outreachDetails}
                        viewOnly={true}
                        actionBarPosition={POSITIONS.TOP}
                        actionBarAlign={ALIGN.RIGHT}
                    />
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ViewOutreachDetailsModal;
